<template>
  <div class="info">
    <div class="info_header">
      <div class="info-round">
        <div :class="step==1?'info-f active':'info-f' ">1</div>
        <div class="info-online"></div>
        <div :class="step==2?'info-f active':'info-f' ">2</div>
        <div class="info-online"></div>
        <div :class="step==3?'info-f active':'info-f' ">3</div>
<!--        <div class="info-online"></div>-->
<!--        <div :class="step==4?'info-f active':'info-f' ">4</div>-->
      </div>
      <div class="info-str">
        <div :class="step==1?'info-t active':'info-t' " >基本信息</div>
        <div :class="step==2?'info-t active':'info-t' ">经历描述</div>
        <div :class="step==3?'info-t active':'info-t' ">提交表单</div>
<!--        <div :class="step==4?'info-t active':'info-t' ">提交表单</div>-->
      </div>
    </div>
    <div class="info_list" v-if="step==1">
      <div class="info_title">
        <div>填写基本信息</div>
        <van-uploader :after-read="onRead5" id="idcard" name="idcard">
          <div class="btn-upload-idcard"><img :src="require('@/assets/img/my/srce.png')" alt="">上传身份证</div>
        </van-uploader>
      </div>


      <van-cell-group>
        <van-field v-model="form.realname" label="真实姓名" size="large" placeholder="请输入真实姓名" :rules="[{ required: true, message: '请填写用户名' }]"/>

        <div class="van-cell van-cell--large van-field">
          <div class="van-cell__title van-field__label">
            <span>性别</span>
          </div>
          <div class="van-cell__value van-field__value">
            <div class="van-field__body">
              <van-radio-group v-model="form.gender" direction="horizontal">
                <van-radio :name="1">男</van-radio>
                <van-radio :name="2">女</van-radio>
              </van-radio-group>
            </div>
          </div>
        </div>

        <div class="van-cell van-cell--large van-field">
          <div class="van-cell__title van-field__label">
            <span>二寸蓝底照片</span>
          </div>
          <div class="van-cell__value van-field__value">
            <div class="van-field__body"   style="justify-content: space-between;">
              <van-image v-if="cert_img"  width=".5rem" height=".5rem" :src="cert_img" id="cert_img"/>
              <van-uploader :after-read="onRead5" name="cert_img" ref="upload_cert_img">
                <van-button size="small" color="#6A94ED" plain style="color:#323233">上传照片</van-button>
              </van-uploader>
            </div>
          </div>
        </div>
        <div class="van-cell van-cell--large van-field" v-if="catid==2||catid==3||catid==4">
          <div class="van-cell__title van-field__label">
            <span>{{cert_str}}</span>
          </div>
          <div class="van-cell__value van-field__value">
            <div class="van-field__body"   style="justify-content: space-between;">
              <van-image v-if="cert_img2"  width=".5rem" height=".5rem" :src="cert_img2" id="cert_img2"/>
              <van-uploader :after-read="onRead5"  name="cert_img2" ref="upload_cert_img2">
                <van-button size="small" color="#6A94ED" plain style="color:#323233">上传照片</van-button>
              </van-uploader>
            </div>
          </div>
        </div>

        <div class="van-cell van-cell--large van-field" v-if="(catid==2||catid==3||catid==4) && ((catid==3 || cert_type>0) || (catid==4 && cert_type==0))">
          <div class="van-cell__title van-field__label">
            <span>{{cert_str2}}</span>
          </div>
          <div class="van-cell__value van-field__value">
            <div class="van-field__body"   style="justify-content: space-between;">
              <van-image v-if="cert_img3"  width=".5rem" height=".5rem" :src="cert_img3" id="cert_img3"/>
              <van-uploader :after-read="onRead5" name="cert_img3" ref="upload_cert_img3">
                <van-button size="small" color="#6A94ED" plain style="color:#323233">上传照片</van-button>
              </van-uploader>
            </div>
          </div>
        </div>

        <van-field v-model="form.birthday" @click="showdate=true" size="large" center readonly label="出生年月" placeholder="请选择出生年月" >
          <template #button>
            <van-button size="small"  color="#6A94ED" plain @click="showdate=true"><i class="iconfont icon-rili"></i> 选日期</van-button>
          </template>
        </van-field>
        <van-field v-model="form.idcard" label="身份证号" size="large" placeholder="请输入真实身份证" clearable/>
        <!-- <van-field
                readonly
                clickable
                is-link
                name="picker"
                :value="form.political"
                label="政治面貌"
                placeholder="点击选择政治面貌"
                @click="showPicker = true"
        /> -->

        <van-field
                readonly
                clickable
                name="picker"
                is-link
                :value="form.edu"
                label="最高学历"
                placeholder="点击选择最高学历"
                @click="showPickerEdu = true"
        />


        <van-field v-model="form.address" label="详细地址" type="textarea" size="large" placeholder="请输入详细地址" :rules="[{ required: true, message: '请填写详细地址' }]"/>
        <!--          <van-field v-model="form.mobile" label="联系电话" size="large" placeholder="请输入联系电话" :rules="[{ required: true, message: '请填写联系电话' }]"/>-->

        <!--<van-field v-model="address" label="详细地址" size="large" placeholder="请输入详细地址" />-->
        <van-field v-model="form.mobile" size="large" label="联系电话" placeholder="请输入联系电话" >
          <template #button>
            <van-button size="small"  color="#6A94ED" plain @click="sendCode()"><i class="iconfont icon-shouji"></i>验证码</van-button>
          </template>
        </van-field>
<!--        <van-cell>-->
<!--          <template #default>-->
<!--            <van-button size="small"  color="#6A94ED" plain @click="sendCode()"><i class="iconfont icon-shouji"></i> 获取验证码</van-button>-->
<!--          </template>-->
<!--        </van-cell>-->
        <van-field v-model="form.code" label="验证码" size="large" placeholder="请输入验证码" :rules="[{ required: true, message: '请填写验证码' }]"/>

      </van-cell-group>
      <!-- <van-calendar v-model="showdate" @confirm="onConfirm" :min-date="minDate" :max-date="maxDate" /> -->
      <van-popup v-model="showdate" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          @confirm="onConfirm"
          type="date"
          title="选择年月日"
          :min-date="minDate"
          :max-date="maxDate"
        />
      </van-popup>
      <!-- <van-popup v-model="showPicker" position="bottom">
        <van-picker
                show-toolbar
                :columns="political"
                value-key="label"
                @confirm="onConfirmPolitical"
                @cancel="showPicker = false"
        />
      </van-popup> -->
      <van-popup v-model="showPickerEdu" position="bottom">
        <van-picker
                show-toolbar
                :columns="edu"
                value-key="label"
                @confirm="onConfirmEdu"
                @cancel="showPickerEdu = false"
        />
      </van-popup>
    </div>
    <div class="info_list" v-if="step==2">
      <div class="info_other2">
        <div class="con">
          <div class="con-t">工作简历</div>
          <van-field
                  class="textarea"
                  v-model="resume"
                  rows="5"
                  type="textarea"
                  placeholder="写点什么吧，让你的简历更漂亮 "
          />
        </div>
        <div class="con two">
          <div class="con-t">运动成就</div>
          <van-field
                  class="textarea"
                  v-model="achievement"
                  rows="5"
                  type="textarea"
                  placeholder="生命在于运动，运动成就不一样的美。请记录您的运动成就 ... "
          />
        </div>
      </div>
      <div class="div-box">
      <div class="info_title">
        <div>教育经历</div>
        <div class="btn-upload-idcard" v-if="!showedu" @click="add"><img :src="require('@/assets/img/my/add.png')" alt="">新增经历</div>
      </div>
      <template v-if="showedu">
        <van-cell-group >
          <van-field v-model="forms.date" @click="showdates=true" size="large" center readonly label="毕业时间" placeholder="请选择时间" >
            <template #button>
              <van-button size="small" color="#6A94ED" plain @click="showdates=true"><i class="iconfont icon-rili"></i> 选日期</van-button>
            </template>
          </van-field>
          <van-field v-model="forms.school" label="毕业学校" size="large" placeholder="请输入学校" />
          <van-field v-model="forms.profession" label="专业" size="large" placeholder="请输入专业" />

         <!--  <van-field
                  readonly
                  clickable
                  name="picker"
                  is-link
                  :value="form.political"
                  label="专业"
                  placeholder="请选择专业"
                  @click="showPicker = true"
          /> -->

          <van-field
                  readonly
                  clickable
                  name="picker"
                  :value="forms.year"
                  label="学制"
                  is-link
                  placeholder="请选择学制"
                  @click="showyear = true"
          />

          <van-field
                  readonly
                  clickable
                  name="picker"
                  :value="forms.degree"
                  label="学位"
                  is-link
                  placeholder="请选择学位"
                  @click="showdegree = true"
          />

        </van-cell-group>
        <div class="bot2">
          <div class="mvbutton rst" @click="rst">重置</div>
          <div class="mvbutton save" @click="save">保存</div>
        </div>
      </template>

      <div class="hos" v-for="(item,index) in edus" :key="index" v-if="edus.length>0">
        <div class="hos-t">
          <div>{{index+1}}学历</div>
          <div><div class="mvbutton" @click="del(item)">删除</div> | <div class="mvbutton" @click="edit(item)">编辑</div></div>
        </div>
        <div class="hotlist">
          <div>
            <div>毕业时间：</div>
            <div>{{item.date}}</div>
          </div>
          <div>
            <div>毕业学校：</div>
            <div>{{item.school}}</div>
          </div>
          <div>
            <div>专业：</div>
            <div>{{item.profession}}</div>
          </div>
          <div>
            <div>学制：</div>
            <div>{{item.year}}</div>
          </div>
          <div>
            <div>学位：</div>
            <div>{{item.degree}}</div>
          </div>
        </div>
      </div>
      </div>
      <van-popup v-model="showdates" position="bottom">
        <van-picker
                show-toolbar
                :columns="dates"
                value-key="label"
                @confirm="onConfirmDate"
                @cancel="showdates = false"
        />
      </van-popup>
      <van-popup v-model="showyear" position="bottom">
        <van-picker
                show-toolbar
                :columns="years"
                value-key="label"
                @confirm="onConfirmYear"
                @cancel="showyear = false"
        />
      </van-popup>
      <van-popup v-model="showdegree" position="bottom">
        <van-picker
                show-toolbar
                :columns="degrees"
                value-key="label"
                @confirm="onConfirmDegree"
                @cancel="degree = false"
        />
      </van-popup>
    </div>
    <div class="info_other" v-if="step==31">
      <div class="con">
        <div class="con-t">工作简历</div>
        <van-field
          class="textarea"
          v-model="resume"
          rows="5"
          type="textarea"
          placeholder="写点什么吧，让你的简历更漂亮 "
        />
      </div>
      <div class="con two">
        <div class="con-t">运动成就</div>
        <van-field
          class="textarea"
          v-model="achievement"
          rows="5"
          type="textarea"
          placeholder="生命在于运动，运动成就不一样的美。请记录您的运动成就 ... "
        />
      </div>
    </div>
    <div class="info_other" v-if="step==3">
      <div class="con">
        <div v-if="catid <2">
           <div class="con-t">恭喜你！</div>
           <div class="success-msg">您的信息已填写完成！</div>
        </div>
        <div v-else>
          <div class="con-t">恭喜你,就差最后一步啦！</div>

          <div class="van-cell van-cell--large van-field">
            <van-checkbox v-model="other.issh" shape="square" >是否持上海市游泳救生协会颁发的救生员证</van-checkbox>
          </div>
          <div class="van-cell van-cell--large van-field">
            <van-checkbox v-model="other.isyear3" shape="square" >是否期满三年</van-checkbox>
          </div>

          <div class="van-cell van-cell--large van-field">
            <van-checkbox v-model="other.istuoshen" shape="square" >是否有脱审</van-checkbox>
          </div>

          <div class="van-cell van-cell--large van-field">
            <van-checkbox v-model="other.isshigu" shape="square" >是否有重大责任事故</van-checkbox>
          </div>
          <div class="con-s">注：打钩表示是</div>
        </div>
      </div>
    </div>
    <div class="check-box" v-if="step==3">
      <van-checkbox v-model="checked" shape="square" class="el-check">填报信息真实有效，否则责任自负</van-checkbox>
    </div>
    <div class="footer">
      <div class="mvbutton" @click="gonext" v-if="step!=3 || (step==3 && checked)">{{step==3?'完成':'下一步'}}</div>
      <div class="mvbutton btn-disabled" @click="checkAlert"  v-else-if="step==3 && !checked">{{step==3?'完成':'下一步'}}</div>
    </div>
  </div>

</template>
<script>
  import utils from '../../../libs/utils'
  import {Cell, CellGroup,Field,RadioGroup, Radio,Button,Calendar,Uploader,Toast,Picker,Popup,Dialog,DatetimePicker,Image,CheckboxGroup,Checkbox} from 'vant'
  import axios from 'axios'
  import {host} from '../../../libs/config'
  export default {
    name: "coinRecord",
    components: {
      vanCell:Cell,
        Cell,
      vanCellGroup:CellGroup,
      vanField:Field,
      vanRadioGroup:RadioGroup,
      vanRadio:Radio,
      vanButton:Button,
      vanCalendar:Calendar,
      vanUploader:Uploader,
      vanPicker:Picker,
      vanPopup:Popup,
      VanImage:Image,
      Dialog,
      vanDatetimePicker:DatetimePicker,
      vanCheckboxGroup:CheckboxGroup,
      vanCheckbox:Checkbox
    },
    data() {
      return {
        page:1,
        List: [],
        political:[],
        edu:[],
        finished:false,
        loading:false,
        form:{"realname":"","address":"","gender":1,"idcard":"","mobile":"","birthday":"","idcard_img":"",skuid:'','cert_img':"",'cert_img2':"",'cert_img3':""},
        name:'',
        gender:1,
        birthday:'',
        idcard:'',
        address:'',
        phone:'',
        step:1,
        showdate:false,
        minDate: new Date(1960, 0, 1),
        maxDate: new Date(2020, 0, 31),
        showPicker:false,
        showPickerEdu:false,
        resume:'',
        edus:[],
        forms:{},
        showedu:false,
        showyear:false,
        showdegree:false,
        showdates:false,
        degrees:[],
        years:[],
        dates:[],
        type:1,//1新增，2修改
        id:'',
        achievement:'',
        venues:[],
        skuid:this.$route.query.skuid?parseInt(this.$route.query.skuid):"",
        currentDate: new Date(),
        cert_img: '',
        cert_img2: '',
        cert_img3: '',
        catid: '',
        cert_str:'证书照片',
        cert_str2:'证书照片',
        cert_type:'',
        checked:false,
        other:{isyear3:'',issh:'',istuoshen:'',isshigu:''}
      }
    },
    methods: {
      checkAlert()
      {
        if(!this.checked)
        {
          Dialog.alert({
            title: '提示',
            message: '请确认勾选信息真实有效！',
          }).then(() => {

          });
        }
      },
      add(){
        this.showedu = true
        this.type = 1
        this.forms = {
          date:'',
          year:'',
          degree:'',
          school:'',
          profession:''
        }
      },
      edit(item){
        this.type=2
        this.id = item.id
        this.showedu = true
        this.forms.date =item.date
        this.forms.year =item.year
        this.forms.degree =item.degree
        this.forms.school =item.school
        this.forms.profession =item.profession
      },
      del(item){
        this.$dialog.confirm({
          title: '确认',
          message: '是否确认删除该学历',
        })
          .then(() => {
            // on confirm
            this.$api.system.edu({op:9,id:item.id}).then((res)=>{
              if(res.code == 200)
              {
                this.getEdus()
              }
            })
          })
          .catch(() => {
            // on cancel
          });

      },
      onConfirm(date) {
        this.showdate = false;
        this.form.birthday = this.formatDate(date);
      },
      formatDate(date) {
        return`${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
      },
      rst(){
        this.forms = {
          date:'',
          year:'',
          degree:'',
          school:'',
          profession:''
        }
      },
      save(){
        if(this.forms.date ==''|| this.forms.year == '' || this.forms.degree == '' || this.forms.school == '' || this.forms.profession ==''){
          this.$toast.fail('请补全信息');
          return;
        }
        if(this.type==1){
          this.$api.system.edu({op:1,forms:JSON.stringify(this.forms)}).then((res)=>{
            if(res.code == 200)
            {
              this.getEdus()
              this.rst()
              this.showedu = false
            }
          })
        }else{
          let query = this.forms
          query.id = this.id
          this.$api.system.edu({op:1,id:this.id,forms:JSON.stringify(query)}).then((res)=>{
            if(res.code == 200)
            {
              // this.getEdus()
              this.rst()
              this.showedu = false
            }
          })
        }
      },

      onRead5(file,e) {
        console.log(e,'e')
        let name = e.name
        let query = new FormData();
        query.append('file',file.file);
        var token = localStorage.getItem('token');
        let config = {
          headers: { //添加请求头
            'Content-Type': 'multipart/form-data',
            'access-token': token,
          }
        }
        let that = this
        let upurl = host+'/api/v1/file/images'
        if(name=='idcard')
          upurl = host+'/api/v1/file/idcard'

        let load = Toast.loading({
          message: '系统处理中...',
          forbidClick: true,
        });
        axios.post(upurl, query, config).then((res) => {
          if(res.data.code == 200)
          {
            // console.log(res)
            Toast.fail('上传成功')
            switch (name)
            {
              case 'idcard':
                let idcardinfo = res.data.data.idcardinfo;
                that.form.address = idcardinfo.address
                that.form.birthday = idcardinfo.birthday
                that.form.gender = idcardinfo.gender
                that.form.idcard = idcardinfo.idcard
                that.form.idcard_img = res.data.data.url
                that.form.realname = idcardinfo.realname
                console.log(that.form,'form')
                 break;
              case 'cert_img':
                that.$set(that.form,"cert_img", res.data.data.url)
                that.form.cert_img = res.data.data.url
                that.cert_img = res.data.data.url
                break;
              case 'cert_img2':
                that.$set(that.form,"cert_img2", res.data.data.url)
                that.form.cert_img2 = res.data.data.url
                that.cert_img2 = res.data.data.url
                break;
              case 'cert_img3':
                that.$set(that.form,"cert_img3", res.data.data.url)
                that.form.cert_img3 = res.data.data.url
                that.cert_img3 = res.data.data.url
                break;
              default:
                break;
            }
            load.close();
          }else{
            load.close();
            Toast.fail(res.data.message);
          }
        }).catch((err) => {
          load.close();
          Toast.fail('系统异常')
        });
      },
      getConfig()
      {
        this.$api.user.config({'config':'political,edu,school_system,degree','type':'select'}).then((res)=>{
          if(res.code == 200)
          {
            this.political = res.data.political
            this.edu = res.data.edu
            this.years = utils.getObjectValues(res.data.school_system,'label')
            this.degrees =utils.getObjectValues(res.data.degree,'label')
              console.log(this.degrees,'')
          }
        })

      },
      getEdus(){
        this.$api.system.edu({op:0}).then((res)=>{
          if(res.code == 200)
          {
            this.edus = res.data
            if(res.data.length==0){
              this.showedu = true
            }
          }
        })
      },
      onConfirmDate(obj)
      {
        this.forms.date = obj;
        this.showdates = false;
      },
      onConfirmYear(obj)
      {
        this.forms.year = obj;
        this.showyear = false;
      },
      onConfirmDegree(obj)
      {
        console.log(obj)
        this.forms.degree = obj;
        this.showdegree = false;
      },
      onConfirmPolitical(obj)
      {
        this.form.political = obj.label;
        this.showPicker = false;
      },
      onConfirmEdu(obj)
      {
        this.form.edu = obj.label;
        this.showPickerEdu = false;
      },
        sendCode()
        {
            this.$api.user.sendCode({mobile:this.form.mobile}).then((res)=>{
                if(res.code == 200)
                {
                   Toast.success("发送成功!")
                }
            });
        },
      gonext(){
        // let
         switch(this.step){
              case 1:
                let upload_cert_img = this.$refs.upload_cert_img;
                let upload_cert_img2 = this.$refs.upload_cert_img2;//document.getElementById('cert_img');
                let upload_cert_img3 = this.$refs.upload_cert_img3;//document.getElementById('cert_img3');
                let cert_img = document.getElementById('cert_img');
                let cert_img2 = document.getElementById('cert_img2');
                let cert_img3 = document.getElementById('cert_img3');




                  if(this.form.idcard_img =='' || !this.form.idcard_img)
                  {
                    this.$toast.fail('请上传身份证照片');
                    return;
                  }

                // if(this.form.cert_img =='' || !this.form.cert_img){
                //   console.log(this.form,'this.form');
                //   this.$toast.fail('请上传免冠小二寸蓝底照片');
                //   return;
                // }
                // let cert_img2 = document.getElementById('cert_img2');
                // if(cert_img2 != undefined)
                // {
                //   console.log(cert_img2,'cert_img2')
                // }

                if(upload_cert_img && !cert_img){
                  this.$toast.fail('请上传免冠小二寸蓝底照片');
                  return;
                }

                if(upload_cert_img2 && !cert_img2){
                  this.$toast.fail('请上传证书照片');
                  return;
                }

                if(upload_cert_img3 && !cert_img3){
                  this.$toast.fail('请上传证书照片');
                  return;
                }
                  this.$api.user.editUserInfo({op:1,step:this.step,forms:JSON.stringify(this.form)}).then((res)=>{
                      if(res.code == 200)
                      {
                         this.step = 2;
                         this.getEdus()
                         // this.getachievement()
                      }
                  })
                  // this.step = 2;
                  break;
              case 2:
                if(this.edus.length===0){
                  this.$toast.fail('请添加至少一个学历');
                  return;
                }
                this.$api.system.achievement({op:1,resume:this.resume,achievement:this.achievement}).then((res)=>{
                  if(res.code == 200)
                  {
                    this.step = 3;
                  }
                })
                  break;
              case 3:
                this.$api.order.submintOrder({skuid:this.skuid,forms:JSON.stringify(this.form),other:JSON.stringify(this.other),edus:JSON.stringify(this.edus),resume:this.resume,achievement:this.achievement}).then((res)=>{
                  if(res.code == 200)
                  {
                      Dialog.alert({
                          title: '提示',
                          message: '您已报名成功，请耐心等待教员审核！',
                      }).then(() => {
                          this.$router.push({name:'exchange'})
                      });
                  }
                })
                break;
          }
      },
      getVenueList()
      {
        this.$api.jobs.jobConfig({fields:'venue'}).then((res)=>{
          if(res.code==200){

            //场馆
            this.venues = res.data.venue;

          }
          this.finished   =   true
          this.loading = false;
        })
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.getConfig()
        // this.getVenueList()
        // this.getEdus()
        // this.getinfo()
        // this.getachievement()
        var d = new Date();
        this.maxDate = new Date(d.getFullYear(),d.getMonth(),d.getDay()-1);
        this.forms.skuid = this.$route.query.skuid?parseInt(this.$route.query.skuid):""
        this.catid = this.$route.query.cat_id?parseInt(this.$route.query.cat_id):""
        this.cert_type = this.$route.query.cert_type?parseInt(this.$route.query.cert_type):""
        let str = '证书照片';
        switch (this.catid)
        {
          case 1:
            str = '救生员证';
            break;
          case 2:
            str = '救生员证(初)';
            break;
          case 3:
            str = '救生员证';
            break;
        }
        this.cert_str = str;

        let str2 = '资格证';
        switch (this.cert_type)
        {
          case 1:
            str2 = '资格证(初)';
            break;
          case 2:
            str2 = '资格证(初)';
            break;
          case 3:
            str2 = '资格证';
            break;
        }
        this.cert_str2 = str2;


        for(let i = 1990;i<=2020;i++){
          let y = i + '年'
          this.dates.push(y)
        }
      })
    }
  }
</script>

<style lang="less" src="./index.less" scoped></style>
<style lang="less" scoped>
.info
{
  .el-check
  {
    font-size: 0.28rem;
    box-sizing: border-box;
    padding-left: .5rem;
    padding-bottom: 2rem;
  }
  .btn-disabled
  {
    background: #999;
  }
  .con-s
  {
    font-size: 0.2rem;
    color: red;
    padding-left: 0.3rem;
  }
}
</style>
